import { Injectable, EventEmitter } from '@angular/core';
import { HttpClient, HttpParams } from '@angular/common/http';
import { AppStateGateway } from '@cigna/cigna-for-brokers/shared/gateways';

@Injectable({
  providedIn: 'root',
})
export class HeaderProfileService {
  constructor(private _http: HttpClient, private _gw: AppStateGateway) {}

  /**
   * Get User Security Profile URL
   */
  getBrokerSecurityProfileUrl() {
    window.open(this._gw.getBrokerSecurityProfileUrl(), '_self');
  }
}
